import React from "react"

import GallerySectionDesktop from "./GallerySectionDesktop"
import GallerySectionMobile from "./GallerySectionMobile"

const GallerySection = ({ section, theme, highlightedField, viewMode = "", deviceType = "desktop" }) => {
  // If viewMode is explicitly set (from preview), use that to determine which component to show
  if (viewMode === "mobile") {
    return <GallerySectionMobile section={section} theme={theme} highlightedField={highlightedField} />
  }

  if (viewMode === "desktop") {
    return <GallerySectionDesktop section={section} theme={theme} highlightedField={highlightedField} />
  }

  // Use server-side device detection for public pages
  if (deviceType === "mobile") {
    return <GallerySectionMobile section={section} theme={theme} highlightedField={highlightedField} />
  }

  // Default to desktop for desktop devices
  return <GallerySectionDesktop section={section} theme={theme} highlightedField={highlightedField} />
}

export default GallerySection
